import { render, staticRenderFns } from "./home.vue?vue&type=template&id=052a614d&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=052a614d&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=052a614d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a614d",
  null
  
)

export default component.exports